import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import AdmMobile from "./AdmMobile";
import AdmDesktop from "./AdmDesktop";

function Adm({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <AdmMobile app={app} config={config} />
  ) : (
    <AdmDesktop app={app} config={config} />
  );
}

Adm.defaultProps = {
  app: null,
  config: {},
};

Adm.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Adm;
